import axiosInstance from "./client";
import {
  TCategoryData,
  TCategoryAddData,
  TCategoryEditData,
  TCategoryDetailData,
} from "~/types";

export const getCategoryList = async (
  walletId: string
): Promise<TCategoryData[]> => {
  const response = await axiosInstance.get(
    `/category/all?walletInforID=${walletId}`
  );

  return response.data;
};

export const getCategoryInfo = async (
  categoryId: string
): Promise<TCategoryDetailData> => {
  const response = await axiosInstance.get(
    `category/details?categoryID=${categoryId}`
  );

  const category = response.data;
  return {
    id: category.categoryID,
    name: category.categoryName,
    walletId: category.walletInforID,
    ...category,
  };
};

export const addCategory = async (data: TCategoryAddData) => {
  let categoryData: any;
  categoryData = {
    categoryName: data.name,
    walletInforID: data.walletId,
    transactionType: data.type,
  };

  if (data.parentId) {
    categoryData.parentCategoryID = data.parentId;
  }

  const response = await axiosInstance.post(`/category/create`, categoryData);
  return response;
};

export const editCategory = async (data: TCategoryEditData) => {
  let categoryData: any;
  categoryData = {
    categoryID: data.id,
    categoryName: data.name,
  };

  const response = await axiosInstance.put(`/category/update`, categoryData);
  return response;
};

export const deleteCategory = async (categoryId: string) => {
  const response = await axiosInstance.delete(
    `/category/delete?categoryID=${categoryId}`
  );
  return response;
};
